class UoeTerms extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input');
    this.addEventListener('click', (event) => {
      if(this.checkbox.checked){
        document.querySelector('button.product-form__submit').disabled = false;
      }else{
        document.querySelector('button.product-form__submit').disabled = true;
      }
    });
    if(!this.checkbox.checked){
      document.querySelector('button.product-form__submit').disabled = true;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, this.checkVariant.bind(this));
  }

  checkVariant = () => {
    if(!this.checkbox.checked){
      document.querySelector('button.product-form__submit').disabled = true;
    }
  };

}

customElements.define('uoe-terms', UoeTerms);